import { autoinject } from "aurelia-framework";
import { FetchClient } from "../common/fetch-client";
import config from "../common/config";
import { IPaginationNew } from "../resources-vue/vue-interfaces/i-pagination";
import { ISuccessResponse } from "../resources-vue/vue-interfaces/i-common";
import {
    IConversationListFiltersRequest,
    ICreateThreadRequest,
    ICreateThreadResponse,
    IFPPatient,
    IFPStartCallRequest,
    IGetConversationContactsResponse,
    IGetFPPatientsRequest,
    IGetThreadConversationsByIdRequest,
    IGetThreadConversationsByIdResponse,
    IGetThreadConversationsRequest,
    IGetThreadConversationsResponse,
    IGetThreadMessagesByIdRequest,
    IGetThreadMessagesByIdResponse,
    IThreadListFiltersRequest,
    IThreadListResponse,
    IThreadReplyRequest
} from "../resources-vue/vue-interfaces/messaging-service/i-family-portal";
import {
    IStartConversationRoomResponse,
    ISucessResponse
} from "../resources-vue/vue-interfaces/messaging-service/i-message";

@autoinject()
export class FamilyPortalService {
    private _httpClient: FetchClient;
    private _baseMessagingThreadsUrl: string = `${config.messagingServiceServerURL}/api/v1/threads`;
    private queryHeaders = {
        "X-Chat-AgencyId": "122ec20a-705b-4974-9437-8f6233a6e953"
    };

    public constructor(httpClient: FetchClient) {
        this._httpClient = httpClient;
    }

    public async replyOnThread(query: IThreadReplyRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/reply`)
            .useMethod("POST")
            .useBody(query)
            .useHeaders(this.queryHeaders)
            .fetch<ISuccessResponse>();
    }

    public async getThreadsList(filters: IThreadListFiltersRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/get-thread-list`)
            .useMethod("POST")
            .useBody(filters)
            .useHeaders(this.queryHeaders)
            .fetch<IThreadListResponse>();
    }

    public async getThreadsConversations(
        query: IGetThreadConversationsRequest,
        filters: IConversationListFiltersRequest
    ) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/get-conversations`)
            .useQueryString(query)
            .useMethod("POST")
            .useBody(filters)
            .useHeaders(this.queryHeaders)
            .fetch<IGetThreadConversationsResponse>();
    }

    public async getThreadsConversationsById(conversationGroupId: string, query: IGetThreadConversationsByIdRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/conversations/${conversationGroupId}`)
            .useQueryString(query)
            .useHeaders(this.queryHeaders)
            .fetch<IGetThreadConversationsByIdResponse>();
    }

    public async getThreadMessagesById(threadId: string, query: IGetThreadMessagesByIdRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/messages/${threadId}`)
            .useQueryString(query)
            .useHeaders(this.queryHeaders)
            .fetch<IGetThreadMessagesByIdResponse>();
    }

    public async createThread(query: ICreateThreadRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}`)
            .useMethod("POST")
            .useBody(query)
            .fetch<ICreateThreadResponse>();
    }

    public async resolveThread(conversationThreadId: string) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/threads/resolve`)
            .useMethod("PATCH")
            .useBody({ conversationThreadId })
            .fetch<ICreateThreadResponse>();
    }

    public async startCall(query: IFPStartCallRequest) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/start-call`)
            .useMethod("POST")
            .useBody(query)
            .fetch<IStartConversationRoomResponse>();
    }

    public async declineCall(roomId: string) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/decline-call`)
            .useMethod("POST")
            .useBody({ roomId })
            .fetch<ISucessResponse>();
    }

    public async readConversation(conversationGroupId: string) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/read-conversation`)
            .useMethod("PATCH")
            .useBody({ conversationGroupId })
            .fetch<ISuccessResponse>();
    }

    public async getFamilyContacts(conversationGroupId: string) {
        return await this._httpClient
            .build(`${this._baseMessagingThreadsUrl}/conversations/${conversationGroupId}/contacts`)
            .fetch<IGetConversationContactsResponse>();
    }

    public async getFPPatients(query: IGetFPPatientsRequest) {
        return await this._httpClient
            .build(`${config.messagingServiceServerURL}/api/v1/patients/family-portal`)
            .useMethod("POST")
            .useBody(query)
            .fetch<IPaginationNew<IFPPatient>>();
    }
}
